import { Grid, LinearProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import ScreenContainer from 'components/containers/ScreenContainer';
import SearchToolbar from 'components/SearchToolbar';
import SyncReportTable from 'components/SyncReportTable';
import useSyncReports from 'hooks/useSyncReports';
import { FetchSyncReports } from 'lib/models/syncReport';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export default function SyncReport() {
	const { t } = useTranslation();

	const [searchParams, setSearchParams] = useSearchParams({
		search: '',
		page: '0',
		rowsPerPage: '25',
	});
	const [from, setFrom] = useState<moment.Moment | null>(null);

	const [search, setSearch] = useState(searchParams.get('search') || '');
	const [page, setPage] = useState(Number(searchParams.get('page') || 0));
	const [rowsPerPage, setRowsPerPage] = useState(Number(searchParams.get('rowsPerPage') || 10));
	const searchProps = useMemo(() => {
		let searchParams: FetchSyncReports = {
			page,
			rowsPerPage,
			search,
			from: from ? from.format('YYYY-MM-DD') : undefined,
		};
		return searchParams;
	}, [page, rowsPerPage, search, from]);

	const { loading, syncReports, refetch } = useSyncReports(searchProps);
	const handleChangePage = (_: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	function onSearch(value: string) {
		setSearch(value);
	}

	useEffect(() => {
		setSearchParams({
			page: `${page}`,
			rowsPerPage: `${rowsPerPage}`,
			search: `${search}`,
			from: from ? from.format('YYYY-MM-DD') : '',
		});
	}, [setSearchParams, page, rowsPerPage, search]);
	return (
		<ScreenContainer title={'Reporte de sincronizacion'}>
			{/*<Box sx={{ display: 'flex', flexDirection: 'row' }}>
				<SearchToolbar onSearch={onSearch} initialValue={search} />
	</Box>*/}
			<Grid container spacing={2} columns={10} alignItems="center">
				<Grid item xs={10} sm={7} md={6}>
					<SearchToolbar onSearch={onSearch} initialValue={search} />
				</Grid>
				<Grid item xs={10} sm={5} md={3}>
					<DatePicker
						sx={{ width: '100%' }}
						value={from}
						onChange={(newValue) => setFrom(newValue)}
						label={t('common:date')}
						format="DD/MM/YYYY"
					/>
				</Grid>
			</Grid>

			{!!loading && <LinearProgress />}

			<SyncReportTable
				syncReports={syncReports}
				handleChangePage={handleChangePage}
				handleChangeRowsPerPage={handleChangeRowsPerPage}
				page={page}
				rowsPerPage={rowsPerPage}
				onSearch={onSearch}
				initialValue={search}
				refetch={refetch}
			/>
		</ScreenContainer>
	);
}
